import { createWithEqualityFn as create } from 'zustand/traditional';

export const SOFTPAY_APP_ID_KEY = 'SOFTPAY_APP_ID';

interface SoftpayAppIdActions {
  setAppId: (appId: string) => void;
  clearAppId: () => void;
}

export interface SoftpayAppIdState {
  appId?: string;
  actions: SoftpayAppIdActions;
}

export const useSoftpayAppIdStore = create<SoftpayAppIdState>()((set, _get) => ({
  actions: {
    clearAppId: () => {
      localStorage.removeItem(SOFTPAY_APP_ID_KEY);
      set({ appId: undefined });
    },
    setAppId: (appId) => {
      localStorage.setItem(SOFTPAY_APP_ID_KEY, appId?.trim());
      set({ appId });
    },
  },

  appId: (() => {
    try {
      const raw = localStorage.getItem(SOFTPAY_APP_ID_KEY);
      return raw?.trim() || undefined;
    } catch {
      return undefined;
    }
  })(),
}));

export const useSoftpayAppId = () => useSoftpayAppIdStore((state) => state.appId);
export const useSoftpayAppIdActions = () => useSoftpayAppIdStore((state) => state.actions);
